import { useState } from "react";

export const useStateCountdown = (initialState) => useState(initialState);
